module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-blob-7-03ba6f871d38ca12ce3302fe200807a9.svg";